import { Reveal } from "./Reveal";

export default function SectionHeading({ eyebrow, title, sub, align = "left", dark = false }) {
  const alignCls = align === "center" ? "items-center text-center mx-auto" : "items-start";
  return (
    <div className={`flex max-w-2xl flex-col ${alignCls}`}>
      {eyebrow && (
        <Reveal>
          <p className="eyebrow">{eyebrow}</p>
        </Reveal>
      )}
      <Reveal delay={0.08}>
        <h2 className={`mt-3 font-heading text-3xl font-extrabold tracking-tight sm:text-4xl ${dark ? "text-white" : "text-charcoal"}`}>
          {title}
        </h2>
      </Reveal>
      {sub && (
        <Reveal delay={0.16}>
          <p className={`mt-4 text-base leading-relaxed ${dark ? "text-white/70" : "text-slate-500"}`}>{sub}</p>
        </Reveal>
      )}
    </div>
  );
}
